export default __webpack_public_path__ + "static/media/18.ae9b783c.jpg";